import { gql } from '@apollo/client';

export const REMOVE_APPLIED_JOB_NOTES = gql`
  mutation RemoveAppliedJobNotes($jobId: String!, $locale: Locale) {
    setAppliedJobNotes(input: { id: $jobId, notes: "" }) {
      ... on SetAppliedJobNotesSuccess {
        id
      }
      ... on SetAppliedJobNotesFailure {
        errors {
          message(locale: $locale)
        }
      }
    }
  }
`;
